import {
  Box,
  Button,
  CircularProgress,
  styled,
  Typography
} from "@material-ui/core";
import React from "react";
import { formatPrice } from "../../../../helpers/price";
import { RetailProductAvailabilityType } from "../../../../types/airgraft";
import Imgix from "react-imgix";
import OpenInNew from "@material-ui/icons/OpenInNew";

export const ShopButtonLink = styled(Button)(({ theme }) => ({
  width: "100px",
  minHeight: "24px",
  "& .MuiCircularProgress-root": {
    color: theme.palette.common.black
  }
}));

export const LogoImgix = styled(Imgix)(({ theme }) => ({
  width: "auto",
  maxHeight: "30px",
  maxWidth: "120px"
}));

export function RetailProviderItem({
  retailProvider,
  availability,
  isLoadingAvailability
}: {
  retailProvider: Queries.ProductRetailProvidersFragmentQuery["allDatoCmsRetailProvider"]["nodes"][number];
  availability?: RetailProductAvailabilityType;
  isLoadingAvailability?: boolean;
}) {
  const url = availability?.url || retailProvider.url;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      bgcolor="grey.100"
      paddingX={{ xs: 2 }}
      paddingY={{ xs: 1 }}
      mb="1px"
      maxHeight="50px"
      height="50px"
    >
      {/* Retailer logo */}
      {retailProvider.logo && (
        <LogoImgix
          src={retailProvider.logo.url}
          width="200px"
          disableQualityByDPR
          imgixParams={{
            auto: "format,compress"
          }}
          alt={retailProvider.title}
          title={retailProvider.title}
        />
      )}

      {/* No logo: Fallback title */}
      {!retailProvider.logo && (
        <Typography style={{ fontWeight: 600 }}>
          {retailProvider.title}
        </Typography>
      )}

      {/* "Shop" button */}
      <ShopButtonLink
        key={url}
        variant="contained"
        size="small"
        // @ts-ignore
        target="_blank"
        rel="noopener noreferrer"
        color="primary"
        href={url}
        endIcon={
          isLoadingAvailability ? (
            <CircularProgress size="10px" variant="indeterminate" />
          ) : (
            <OpenInNew fontSize="small" />
          )
        }
        data-analytics="product-details.buy-from-retailer"
      >
        {availability?.price
          ? formatPrice(availability.price, { hideCurrencyCode: true })
          : "Shop"}
      </ShopButtonLink>
    </Box>
  );
}
